import { Api } from "./Api";
import axios from "axios";

export class FileApi extends Api {
    constructor() {
        super("file");
    }

    createDocument(file: File): Promise<any> {
        let formData = new FormData();
        formData.append("file", file);
        return axios.post(this.apiUrl + "document", formData);
    }

    deleteDocument(id: number): Promise<any> {
        return axios.delete(this.apiUrl + "document/" + id);
    }

    createPhoto(file: File): Promise<any> {
        let formData = new FormData();
        formData.append("photo", file);
        return axios
            .post(this.apiUrl + "photo", formData)
            .then(function (response) {
                return response.data.data;
            });
    }

    updatePhoto(photo: any): Promise<any> {
        return axios
            .put(this.apiUrl + "photo/" + photo.id, photo)
            .then(function (response) {
                return response.data.data;
            });
    }
}
